import React from 'react'
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, DateTime, Legend, SplineAreaSeries } from '@syncfusion/ej2-react-charts'

import { areaCustomSeries, areaPrimaryXAxis, areaPrimaryYAxis } from '../../data/dummy'
import { useStateContext } from '../../contexts/ContextProvider'
import { ChartsHeader } from '../../components'

const Area = () => {
  const { currentMode } = useStateContext()
  return (
    <div className='m-4 md:m-10 mt-24 p-10 bg-white/50 dark:bg-gray-600/50 backdrop-blur dark:bg-gray-600 rounded-3xl'>
      
      <ChartsHeader 
        category='Spacial'
        title='Space Wave Frequency'
      />
      <div className='flex justify-center'>
        <ChartComponent
          id='area-chart'
          height='420px'
          primaryXAxis={areaPrimaryXAxis}
          primaryYAxis={areaPrimaryYAxis}
          chartArea={{ border: { width: 0 } }}
          tooltip={{ enable: true }}
          background={currentMode === 'Dark' ? '#acacac' : '#fff'}
        >
          <Inject 
            services={[SplineAreaSeries, DateTime, Legend]}
          />
          <SeriesCollectionDirective>
            {areaCustomSeries.map((item, index) => 
              <SeriesDirective 
                key={index} {...item}
              />
            )}
          </SeriesCollectionDirective>
        </ChartComponent>
      </div>
      
    </div>
    
  )
}

export default Area